module.exports = __webpack_public_path__ + "0921b6a2f7c144e00ff2b91409665fbd.jpg";